import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { IntlProvider } from 'react-intl';

import './index.css';
import './styles/ampay-main.css';
import 'remixicon/fonts/remixicon.css';

import Home from './routes/Home';
import Checkout from './routes/Checkout';
import Charging from './routes/Charging';
import Receipt from './routes/Receipt';
import LanguageSelector from './components/LanguageSelector';

const translations = {
  en: require('./lang/en.json'),
  es: require('./lang/es.json'),
};

const getInitialLocale = () => {
  const saved = localStorage.getItem('ampay-lang');
  if (saved && translations[saved]) return saved;
  const browser = navigator.language.split(/[-_]/)[0];
  return translations[browser] ? browser : 'en';
};

export default function App() {
  const pathname = useLocation().pathname;
  const [locale, setLocale] = React.useState(getInitialLocale);

  const handleLocaleChange = (lang) => {
    setLocale(lang);
    localStorage.setItem('ampay-lang', lang);
  };

  return (
    <IntlProvider
      messages={translations[locale]}
      locale={locale}
      defaultLocale="en"
    >
      <LanguageSelector locale={locale} onChange={handleLocaleChange} />
      <div
        className="ampay-container"
        style={pathname.startsWith('/receipt') ? { alignItems: 'unset' } : {}}
      >
        <Routes>
          <Route path="/" exact={true} element={<Home />} />
          <Route path="/checkout/:evseId" exact={true} element={<Checkout />} />
          <Route
            path="/charging/:evseId/:sessionId"
            exact={true}
            element={<Charging />}
          />
          <Route
            path="/receipt/:evseId/:sessionId"
            exact={true}
            element={<Receipt />}
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </IntlProvider>
  );
}
